// extracted by mini-css-extract-plugin
export default {"container":"lO-z","topReviewHeading":"mO-z","criticalReview":"nO-z","favorableReview":"oO-z","vsSeparator":"pO-z"};